import type { PropsWithClassProps } from '@vgn-medien-holding/vgn-fe-components';
import { Image, Link } from '@vgn-medien-holding/vgn-fe-components';
import { twMerge } from 'tailwind-merge';

export interface ImageCardProps
  extends PropsWithClassProps<'ImageCard' | 'Image' | 'ImageDescription' | 'ImageCopyright' | 'ImageText'> {
  imageSrc: string;
  imageAlt: string;
  imageMode?: string;
  objectFit?: string;
  objectPosition?: string;
  description?: string;
  copyright?: string;
  width?: number;
  height?: number;
  sizes?: string;
  fill?: boolean;
  priority?: boolean;
  link?: string;
}

export const ImageCard = ({
  classProps,
  imageSrc,
  imageAlt,
  imageMode,
  description,
  copyright,
  fill,
  width = 940,
  height = 0,
  sizes,
  priority,
  link,
}: ImageCardProps) => {
  return (
    imageSrc && (
      <figure className={twMerge('w-full bg-white shadow-card-sm', classProps?.root)}>
        <Link
          href={link}
          target="_blank"
          noLink={!link}
          classProps={{ root: twMerge('relative block', classProps?.ImageCard) }}
        >
          <Image
            src={imageSrc}
            className={classProps?.Image}
            alt={imageAlt}
            width={width}
            height={height}
            priority={priority}
            fill={fill}
            imageMode={imageMode}
            copyright={copyright}
            sizes={sizes}
          />
        </Link>
        <figcaption className={description || copyright ? 'prose-caption w-full px-3 py-2' : 'hidden'}>
          {description && <span className={'pr-2 [&>p]:inline'} dangerouslySetInnerHTML={{ __html: description }} />}
          {copyright && <span className={'text-gray-500'} dangerouslySetInnerHTML={{ __html: `© ${copyright}` }} />}
        </figcaption>
      </figure>
    )
  );
};
